import React from "react";
import Icon from '@mui/material/Icon';
import { IconButton } from "@mui/material";

type CustomIconType = {
    icon: string,
    label: string,
    onClick?: Function
}

const CustomIcon = (props: CustomIconType) => {
    return (
        <IconButton aria-label={props.label} onClick={() => props.onClick && props.onClick()}>
            <Icon fontSize="medium">{props.icon}</Icon>
        </IconButton>
    );
}

export default CustomIcon;